import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import { getPlatform } from '../../../store/selectors';
import { Platform } from '../../../store/typings';
import AiAssistantProductCard from '../../ProductCard/AiAssistantProductCard';
import Slideshow from '../../Slideshow/Slideshow';
import { AiAssistantRecommendedProductsMessage } from '../types';
import getRecommendedVariantsList from './getRecommendedVariantsList';

type AiAssistantRecommendedProductsProps = {
    messageId: AiAssistantRecommendedProductsMessage['id'];
    products: AiAssistantRecommendedProductsMessage['products'];
};

const AiAssistantRecommendedProducts = ({
    messageId,
    products,
}: AiAssistantRecommendedProductsProps): ReactElement => {
    const platform = useSelector(getPlatform);
    const isAddToCartEnabled = platform === Platform.SHOPIFY;
    const recommendedProducts = getRecommendedVariantsList(products);

    const allItemsLackImages = recommendedProducts.every((product) => !product.imageUrl);

    return (
        <Slideshow
            items={recommendedProducts}
            isWithoutImages={allItemsLackImages}
            renderItem={(item): ReactElement => (
                <AiAssistantProductCard
                    {...item}
                    key={item.id}
                    messageId={messageId}
                    isAddToCartEnabled={isAddToCartEnabled}
                />
            )}
        />
    );
};

export default AiAssistantRecommendedProducts;
